export enum IntelligenceCategories {
  EDD = "EDD",
  DISPOSITION = "DISPOSITION",
}
